export const DELIVERY_TYPES = {
    SINGLE: 1,
    MULTIPLE: 2,
    BULK: 3,
}